import { Injectable } from '@angular/core';
import { BehaviorSubject, ObservedValueOf, Observable } from 'rxjs';
import { TipoProcessoService } from '../tipo-processo/tipo-processo.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import en_Language from "../../../../../assets/i18n/en.json";
import es_Language from "../../../../../assets/i18n/es.json";
import pt_Language from "../../../../../assets/i18n/pt.json";
import { AdvConfigService } from './adv-config.service';
import { LoginService } from '../login/login.service';
import { TrocarSenhaService } from '../login/trocar-senha.service';
import { GeraNovaSenhaService } from '../login/gera-nova-senha.service';
import * as Swal from 'sweetalert2';
import { CadastroPoderesService } from '../cadastro-poderes/cadastro-poderes.service';
import { MonitorProcessosService } from '../monitor-processos/monitor-processos.service';
import { GraficoProcessosService } from '../monitor-processos/grafico-processos.service';
import { AutorizadoresService } from '../cadastro-poderes/autorizadores.service';
import { DocumentosPoderesService } from '../cadastro-poderes/documentos-poderes.service';
import { ProcessosService } from '../cadastro-poderes/processos.service';
import { PerfisAcessoService } from '../tipo-processo/perfis-acesso.service';
import { MomentosAssinaturaService } from '../tipo-processo/momentos-assinatura.service';
import { Router } from '@angular/router';
import { AutorizadoresInternosService } from '../cadastro-poderes-internos/autorizadores-internos.service';
import { CadastroPoderesInternosService } from '../cadastro-poderes-internos/cadastro-poderes-internos.service';
import { ContratosService } from '../contratos/contratos.service';
import { AssinaturaContratosService } from '../assinatura-contratos/assinatura-contratos.service';
import { ContratosInternosService } from '../contratos-internos/contratos-internos.service';
import { FeitoConferidoService } from '../feito-conferido/feito-conferido.service';
import { NiveisServicoService } from '../niveis-servico/niveis-servico.service';

@Injectable({
  providedIn: 'root'
})

export class AppService {

  //Assinaturas de Contrato
  public CadastroContratosFinalizados(): BehaviorSubject<any> {
    return this.assinatura.finalizadosGet$;
  }
  public CadastroContratosAbertos(): BehaviorSubject<any> {
    return this.assinatura.abertosGet$;
  }
  public CadastroContrato(): BehaviorSubject<any> {
    return this.assinatura.contratoGet$;
  }
  public CadastroContratoSumario(): BehaviorSubject<any> {
    return this.assinatura.sumarioGet$;
  }

  //Autorizadores
  public AutorizadorIncluido(): BehaviorSubject<any> {
    return this.autorizadores.autorizadoresPost$;
  }
  public AutorizadorAlterado(): BehaviorSubject<any> {
    return this.autorizadores.autorizadoresPut$;
  }
  public AutorizadorExcluido(): BehaviorSubject<any> {
    return this.autorizadores.autorizadoresDelete$;
  }
  public CadastroAutorizadores(): BehaviorSubject<any> {
    return this.autorizadores.autorizadoresGet$;
  }
  public CadastroProcuradores(): BehaviorSubject<any> {
    return this.autorizadores.autorizadoresGetProc$;
  }

  //Autorizadores Internos
  public AutorizadorInternoIncluido(): BehaviorSubject<any> {
    return this.autorizadoresInternos.autorizadoresPost$;
  }
  public AutorizadorInternoAlterado(): BehaviorSubject<any> {
    return this.autorizadoresInternos.autorizadoresPut$;
  }
  public AutorizadorInternoExcluido(): BehaviorSubject<any> {
    return this.autorizadoresInternos.autorizadoresDelete$;
  }
  public CadastroAutorizadoresInternos(): BehaviorSubject<any> {
    return this.autorizadoresInternos.autorizadoresGet$;
  }
  public CadastroProcuradoresInternos(): BehaviorSubject<any> {
    return this.autorizadoresInternos.autorizadoresGetProc$;
  }

  //Poderes
  public CadastroPoderes(): BehaviorSubject<any> {
    return this.cadastroPoderes.cadastroPoderes$;
  }
  public CadastroPoderesSem(): BehaviorSubject<any> {
    return this.cadastroPoderes.cadastroPoderesSem$;
  }
  public CadastroPoderesInluido(): BehaviorSubject<any> {
    return this.cadastroPoderes.cadastroPoderesPost$;
  }
  public CadastroProcessosPoderes(): BehaviorSubject<any> {
    return this.processosPoderes.processosGet$;
  }
  public ProcessosPoderesIncluido(): BehaviorSubject<any> {
    return this.processosPoderes.processosPost$;
  }
  public ProcessosPoderesAlterado(): BehaviorSubject<any> {
    return this.processosPoderes.processosPut$;
  }
  public ProcessosPoderesExcluido(): BehaviorSubject<any> {
    return this.processosPoderes.processosDelete$;
  }

  //Poderes Internos
  public CadastroPoderesInternos(): BehaviorSubject<any> {
    return this.cadastroPoderesInternos.cadastroPoderesGet$;
  }
  public ProcessosPoderesInternosIncluido(): BehaviorSubject<any> {
    return this.cadastroPoderesInternos.cadastroPoderesPost$;
  }
  public ProcessosPoderesInternosAlterado(): BehaviorSubject<any> {
    return this.cadastroPoderesInternos.cadastroPoderesPut$;
  }
  public ProcessosPoderesInternosExcluido(): BehaviorSubject<any> {
    return this.cadastroPoderesInternos.cadastroPoderesDelete$;
  }
  public CadastroUsuariosCorp(): BehaviorSubject<any> {
    return this.cadastroPoderesInternos.usuariosCorpGet$;
  }

  //Contratos
  public ContratosIncluido(): BehaviorSubject<any> {
    return this.contratos.contratoPost$;
  }

  //Contratos Internos
  public TokenRespondido(): BehaviorSubject<any> {
    return this.contratosInternos.responderTokenPost$;
  }

  public TokenAssinaturaLoteRespondido(): BehaviorSubject<any> {
    return this.contratosInternos.responderTokenAssinaturaLotePost$;
  }
  public RetornoToken(): BehaviorSubject<any> {
    return this.contratosInternos.enviarTokenPost$;
  }
  public RetornoQRCode(): BehaviorSubject<any> {
    return this.contratosInternos.enviarQRCodePost$;
  }
  public RetornoCertificado(): BehaviorSubject<any> {
    return this.contratosInternos.enviarCertificadoPost$;
  }
  public RetornoFileDownload(): BehaviorSubject<any> {
    return this.contratosInternos.fileGet$;
  }
  public CertificadoSelecionado(): BehaviorSubject<any> {
    return this.contratosInternos.selecionarCertificadoGet$;
  }
  public RetornoTokenAssinaturaLote(): BehaviorSubject<any> {
    return this.contratosInternos.enviarTokenAssinaturaLotePost$;
  }

  //Dashboard Processos
  public CarregarGrafico(): BehaviorSubject<any> {
    return this.graficoProcessos.graficoProcessos$;
  }
  public MonitorProcessos(): BehaviorSubject<any> {
    return this.monitorProcessos.monitorProcessos$;
  }
  public MonitorProcessosPaginado(): BehaviorSubject<any> {
    return this.monitorProcessos.monitorProcessosPaginado$;
  }
  public EventoFeitoConferido(): BehaviorSubject<any> {
    return this.monitorProcessos.eventoFeitoConferido$;
  }
  public EmailReenviado(): BehaviorSubject<any> {
    return this.monitorProcessos.reenviarEmail$;
  }
  public HistoricoPoderCliente(): BehaviorSubject<any> {
    return this.monitorProcessos.historicoPoderCliente$;
  }

  //Documentos
  public CadastroDocumentosPoderes(): BehaviorSubject<any> {
    return this.documentosPoderes.documentosGet$;
  }
  public DocumentoPoderIncluido(): BehaviorSubject<any> {
    return this.documentosPoderes.documentosPost$;
  }
  public DocumentoPoderAlterado(): BehaviorSubject<any> {
    return this.documentosPoderes.documentosPut$;
  }
  public DocumentoPoderExcluido(): BehaviorSubject<any> {
    return this.documentosPoderes.documentosDelete$;
  }
  public DocumentoPoderBinario(): BehaviorSubject<any> {
    return this.documentosPoderes.documentosGetBin$;
  }

  //Feito Conferido
  public CadastroFeitoConferido(): BehaviorSubject<any> {
    return this.feitoConferido.feitoConferidoGet$;
  }
  public FeitoConferidoIncluido(): BehaviorSubject<any> {
    return this.feitoConferido.feitoConferidoPost$;
  }

  //Login
  public LoginEncontrado(): BehaviorSubject<any> {
    return this.login.LoginEncontrado$;
  }
  public EmpresasEncontradas(): BehaviorSubject<any> {
    return this.login.EmpresasEncontradas$;
  }
  public NovaSenhaGerada(): BehaviorSubject<any> {
    return this.geraNovaSenha.NovaSenhaGerada$;
  }
  public TrocarSenhaExecutada(): BehaviorSubject<any> {
    return this.trocarSenha.SenhaAlterada$;
  }

  public TokenEncontrado(): BehaviorSubject<any> {
    return this.login.TokenEncontrado$;
  }

  public NovaSenhaCriada(): BehaviorSubject<any> {
    return this.login.TrocarSenha$;
  }


  //Niveis de Serviço
  public NiveisServicoListaEncontrado(): BehaviorSubject<any> {
    return this.niveisServico.niveisServicoListaGet$;
  }
  public NiveisServicoEncontrado(): BehaviorSubject<any> {
    return this.niveisServico.niveisServicoGet$;
  }
  public NiveisServicoAlterado(): BehaviorSubject<any> {
    return this.niveisServico.niveisServicoPost$;
  }

  //Tipos de Processo
  public TipoProcesso(): BehaviorSubject<any> {
    return this.tipoProcesso.tipoProcessoGet$;
  }
  public TipoProcessoConfigurado(): BehaviorSubject<any> {
    return this.tipoProcesso.tipoProcessoConfigGet$;
  }
  public TipoProcessoIncluido(): BehaviorSubject<any> {
    return this.tipoProcesso.tipoProcessoPost$;
  }
  public TipoProcessoAlterado(): BehaviorSubject<any> {
    return this.tipoProcesso.tipoProcessoPut$;
  }
  public TipoProcessoExcluido(): BehaviorSubject<any> {
    return this.tipoProcesso.tipoProcessoDelete$;
  }
  public CadastroMomentosAssinatura(): BehaviorSubject<any> {
    return this.momentosAssinatura.momentoAssinaturaGet$;
  }
  public CadastroTiposAssinatura(): BehaviorSubject<any> {
    return this.momentosAssinatura.tiposAssinaturaGet$;
  }
  public CadastroPerfisAcesso(): BehaviorSubject<any> {
    return this.perfisAcesso.perfilAcessoGet$;
  }

  constructor(
    private advConfig: AdvConfigService,
    private assinatura: AssinaturaContratosService,
    private autorizadores: AutorizadoresService,
    private autorizadoresInternos: AutorizadoresInternosService,
    private cadastroPoderes: CadastroPoderesService,
    private cadastroPoderesInternos: CadastroPoderesInternosService,
    private contratos: ContratosService,
    private contratosInternos: ContratosInternosService,
    private documentosPoderes: DocumentosPoderesService,
    private geraNovaSenha: GeraNovaSenhaService,
    private graficoProcessos: GraficoProcessosService,
    private login: LoginService,
    private monitorProcessos: MonitorProcessosService,
    private momentosAssinatura: MomentosAssinaturaService,
    private niveisServico: NiveisServicoService,
    private processosPoderes: ProcessosService,
    private perfisAcesso: PerfisAcessoService,
    private tipoProcesso: TipoProcessoService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private trocarSenha: TrocarSenhaService,
    private router: Router,
    private feitoConferido: FeitoConferidoService,
  ) {
    translate.setTranslation('en', en_Language);
    translate.setTranslation('es', es_Language);
    translate.setTranslation('pt', pt_Language);
  }

  public calIdioma: any;

  //Assinaturas de Contrato
  public ContratosFinalizadosPesquisar() {
    return this.assinatura.getFinalizados();
  }
  public ContratosAbertosPesquisar() {
    return this.assinatura.getAbertos();
  }
  public ContratoPesquisar(id_contrato) {
    return this.assinatura.getContrato(id_contrato);
  }
  public ContratoSumarioPesquisar(id_contrato) {
    return this.assinatura.getContratoSumario(id_contrato);
  }

  //Monitor Processos
  public MonitorProcessosPesquisar() {
    return this.monitorProcessos.getMonitorProcessos();
  }

  public MonitorProcessosPesquisarPaginado(busca) {
    return this.monitorProcessos.getMonitorProcessosPaginado(busca);
  }
  public EventoFeitoConferidoEnviar(evento) {
    return this.monitorProcessos.eventoFeitoConferidoPost(evento);
  }
  public ReenviarEmail(id_cliente_poder) {
    return this.monitorProcessos.reenviarEmail(id_cliente_poder);
  }
  public HistoricoPoderClientePesquisar(id_cliente_poder) {
    return this.monitorProcessos.getHistoricoPoderCliente(id_cliente_poder);
  }

  //Poderes
  public CadastroPoderesPesquisar() {
    return this.cadastroPoderes.get();
  }
  public CadastroPoderesSemPesquisar() {
    return this.cadastroPoderes.getAutorizador();
  }
  public CadastroPoderesInluir(cliente) {
    return this.cadastroPoderes.post(cliente);
  }
  public CadastroProcessosPoderesPesquisar(id_cliente) {
    return this.processosPoderes.get(id_cliente);
  }
  public InserirProcessosPoderes(faixa: any) {
    return this.processosPoderes.post(faixa);
  }
  public AlterarProcessosPoderes(faixa: any) {
    return this.processosPoderes.put(faixa);
  }
  public DeletarProcessosPoderes(faixa: any) {
    return this.processosPoderes.del(faixa);
  }

  //Poderes Internos
  public CadastroPoderesInternosPesquisar() {
    return this.cadastroPoderesInternos.get();
  }
  public InserirProcessosPoderesInternos(faixa: any) {
    return this.cadastroPoderesInternos.post(faixa);
  }
  public AlterarProcessosPoderesInternos(faixa: any) {
    return this.cadastroPoderesInternos.put(faixa);
  }
  public DeletarProcessosPoderesInternos(faixa: any) {
    return this.cadastroPoderesInternos.del(faixa);
  }
  public CadastroUsuariosCorpPesquisar(busca) {
    return this.cadastroPoderesInternos.obterUsuariosCorp(busca);
  }

  //Tipos de Processo
  public TipoProcessoPesquisar() {
    return this.tipoProcesso.get();
  }
  public TipoProcessoConfiguradoPesquisar(id_cliente) {
    return this.tipoProcesso.configGet(id_cliente);
  }
  public InserirTipoProcesso(tipoProcesso: any) {
    this.tipoProcesso.post(tipoProcesso);
  }
  public AlterarTipoProcesso(tipoProcesso: any) {
    this.tipoProcesso.put(tipoProcesso);
  }
  public ExcluirTipoProcesso(tipoProcesso: any) {
    this.tipoProcesso.del(tipoProcesso);
  }
  public PerfisAcessoPesquisar() {
    this.perfisAcesso.get();
  }
  public MomentosAssinaturaPesquisar() {
    this.momentosAssinatura.get();
  }
  public TiposAssinaturaPesquisar() {
    this.momentosAssinatura.getTiposAss();
  }

  //Contratos
  public IncluirContrato(contrato: any) {
    this.contratos.uploadContrato(contrato);
  }

  //Contratos Internos
  public enviarToken(chave) {
    this.contratosInternos.postEnviarToken(chave);
  }
  public enviarQRCode() {
    this.contratosInternos.postEnviarQRCode();
  }
  public enviarCertificado(chave) {
    this.contratosInternos.postEnviarCertificado(chave);
  }
  public responderToken(chave, token) {
    this.contratosInternos.postResponderToken(chave, token);
  }

  public responderTokenAssinaturaLote(model) {
    this.contratosInternos.postResponderTokenAssinaturaLote(model);
  }

  public obterFile(url) {
    this.contratosInternos.downloadFile(url);
  }
  public selecionarCertificado() {
    this.contratosInternos.getSelecioneCertificado();
  }

  public enviarTokenAssinaturaLote(model) {
    this.contratosInternos.postEnviarTokenAssinaturaLote(model);
  }

  //Documentos
  public InserirDocumentoPoderes(documento: any) {
    this.documentosPoderes.post(documento);
  }
  public AlterarDocumentoPoderes(documento: any) {
    this.documentosPoderes.put(documento);
  }
  public ExcluirDocumentoPoderes(documento: any) {
    this.documentosPoderes.del(documento);
  }
  public DocumentosPoderesPesquisar(id_cliente) {
    this.documentosPoderes.get(id_cliente);
  }
  public DocumentosPoderesBinarioPesquisar(id_documento) {
    this.documentosPoderes.getBin(id_documento);
  }

  //Feito Conferido
  public FeitoConferidoPesquisar() {
    return this.feitoConferido.get();
  }
  public InserirFeitoConferido(evento) {
    return this.feitoConferido.post(evento);
  }

  //Autorizadores
  public AutorizadoresPesquisar(id_cliente) {
    this.autorizadores.get(id_cliente);
  }
  public ProcuradoresPesquisar(id_cliente) {
    this.autorizadores.getProc(id_cliente);
  }
  public InserirAutorizador(autorizador: any) {
    this.autorizadores.post(autorizador);
  }
  public AlterarAutorizador(autorizador: any) {
    this.autorizadores.put(autorizador);
  }
  public ExcluirAutorizador(autorizador: any) {
    this.autorizadores.del(autorizador);
  }

  //Autorizadores Internos
  public AutorizadoresInternosPesquisar() {
    this.autorizadoresInternos.get();
  }
  public ProcuradoresInternosPesquisar() {
    this.autorizadoresInternos.getProc();
  }
  public InserirAutorizadorInterno(autorizador: any) {
    this.autorizadoresInternos.post(autorizador);
  }
  public AlterarAutorizadorInterno(autorizador: any) {
    this.autorizadoresInternos.put(autorizador);
  }
  public ExcluirAutorizadorInterno(autorizador: any) {
    this.autorizadoresInternos.del(autorizador);
  }

  //Login
  public AlteraSenha(alteracaoSenha: any) {
    this.trocarSenha.altera(alteracaoSenha);
  }
  public LoginPesquisar(login: any) {
    this.login.get(login);
  }
  public EmpresasPesquisar() {
    this.login.getEmpresas();
  }
  public GeraNovaSenha(alteracaoSenha: any) {
    this.geraNovaSenha.gera(alteracaoSenha);
  }
  public GraficoProcessosPesquisar() {
    this.graficoProcessos.getGrafico();
  }


  public TrocarSenhaObterTokenPesquisar(login: any) {
    this.login.obterTokenTrocarSenha(login);
  }

  public TrocarSenhaPesquisar(login: any) {
    this.login.TrocarSenha(login);
  }


  //Niveis de Serviço
  public NiveisServicoListaPesquisar() {
    this.niveisServico.getLista();
  }
  public NiveisServicoPesquisar() {
    this.niveisServico.get();
  }
  public NiveisServicoAlterar(lista: any) {
    this.niveisServico.post(lista);
  }

  //Funções Gerais
  public obterXML() {
    this.advConfig.get();
  }
  public retornoXML(): BehaviorSubject<any> {
    return this.advConfig.advConfig$;
  }

  public pData = [];

  public sbSelecionarIdioma(idioma: string) {
    switch (idioma) {
      case "pt":
        this.calIdioma = {
          firstDayOfWeek: 0,
          dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
          dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
          dayNamesMin: ["Do", "Sg", "Te", "Qu", "Qn", "Se", "Sa"],
          monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
          monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          today: 'Hoje',
          clear: 'Limpar',
          dateFormat: 'mm/dd/yy',
          weekHeader: 'Wk'
        };
        break;
      case "en":
        this.calIdioma = {
          firstDayOfWeek: 0,
          dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          today: 'Today',
          clear: 'Clear',
          dateFormat: 'mm/dd/yy',
          weekHeader: 'Wk'
        };
        break;
      case "es":
        this.calIdioma = {
          firstDayOfWeek: 0,
          dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
          dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sáb"],
          dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
          monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
          monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
          today: 'Hoy',
          clear: 'Claro',
          dateFormat: 'mm/dd/yy',
          weekHeader: 'Wk'
        };
        break;
    }
    this.translate.use(idioma);
  }

  public validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return false;
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999")
      return false;
    // Valida 1o digito	
    var add = 0;
    for (var i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    var rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
      return false;
    // Valida 2o digito	
    add = 0;
    for (i = 0; i < 10; i++)
      add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
      return false;
    return true;
  }

  public validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return false;

    if (cnpj.length != 14)
      return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999")
      return false;

    // Valida DVs
    var tamanho = cnpj.length - 2
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return false;

    return true;
  }

  public sbGetTraducaoAuto(value: string): Observable<any> {
    return this.translate.stream(value);
  }

  public sbGetTraducao(value: string): Observable<any> {
    return this.translate.get(value)
  }

  public sbAbrirModal(id: string) {
    $("#" + id).show();
    $("#" + id).parents("body").addClass("modal-open");
  };

  public sbFecharModal(id: string) {
    $("#" + id).hide();
    $("#" + id).parents("body").removeClass("modal-open");
  };

  public replaceAll(str, find, replace) {
    return str.split(find).join(replace);
  }

  public fnRemoverMascara(texto: string): string {
    texto = this.replaceAll(texto, ",", "");
    texto = this.replaceAll(texto, ".", "");
    texto = this.replaceAll(texto, "/", "");
    texto = this.replaceAll(texto, "-", "");
    texto = this.replaceAll(texto, "_", "");
    return texto;
  }

  public redir(rota1, rota2 = ['menus']) {
    try {
      if (rota1[0] == '') rota2 = null;
      this.router.navigate([{
        outlets: {
          sidebar: rota2,
          primary: rota1
        }
      }], { skipLocationChange: true });
    } catch (e) {
      this.sbExibirAlerta("error", this.translate.instant('geral.mensagens.ops'), this.translate.instant('geral.mensagens.suporte'));
    }
  }

  public sbExibirAlerta(tipo: Swal.SweetAlertIcon, titulo: string, msg: string): void {
    Swal.default.fire({
      title: titulo,
      html: msg,
      icon: tipo,
      timer: 0,
      showCancelButton: false,
      showConfirmButton: true
    });
  }

  public sbExibirNotificacao(tipo: string, titulo: string, msg: string): void {
    switch (tipo) {
      case "success":
        this.toastr.success(msg, titulo, {
          timeOut: 3000,
          enableHtml: true
        });
        break;
      case "info":
        this.toastr.info(msg, titulo, {
          timeOut: 3000,
          enableHtml: true
        });
        break;
      case "warning":
        this.toastr.warning(msg, titulo, {
          timeOut: 3000,
          enableHtml: true
        });
        break;
      case "danger":
        this.toastr.error(msg, titulo, {
          timeOut: 3000,
          enableHtml: true
        });
        break;
    }
  }
}
